import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type UserSurveyConditionConfigDataFragment = { operator: Types.FilterOperatorEnum, actions: Array<{ actionType: Types.UserSurveyQuestionConditionActionTypeEnum, properties?: Array<{ type: Types.FilterPropertyTypeEnum, values?: Array<string> | null }> | null }>, conditions: Array<{ operator: Types.FilterOperatorEnum, typeCast?: Types.TypeCastEnum | null, value: string, property: { type: Types.FilterPropertyTypeEnum, value: string } }> };


export type UserSurveyConditionConfigDataFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type UserSurveyQuestionsEditorFragment = { id: string, blockType?: Types.UserSurveyQuestionBlockTypeEnum | null, order: number, questionId?: string | null, commentTitle?: string | null, conditional?: boolean | null, settings?: { isHidden?: boolean | null, isOptional: boolean, allowComments: boolean, allowAttachmentsInResponse?: boolean | null } | null, conditionConfigs?: Array<{ operator: Types.FilterOperatorEnum, actions: Array<{ actionType: Types.UserSurveyQuestionConditionActionTypeEnum, properties?: Array<{ type: Types.FilterPropertyTypeEnum, values?: Array<string> | null }> | null }>, conditions: Array<{ operator: Types.FilterOperatorEnum, typeCast?: Types.TypeCastEnum | null, value: string, property: { type: Types.FilterPropertyTypeEnum, value: string } }> }> | null };


export type UserSurveyQuestionsEditorFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type UserSurveyEditorFragment = { id: string, name: string, status?: Types.UserSurveyStatusEnum | null, type: Types.UserSurveyTypeEnum, description?: string | null, publicId?: string | null, subWorkspaceIds?: Array<string> | null, coverOffset?: number | null, anonymityThreshold?: number | null, createdByType: Types.UserSurveyCreatedByTypeEnum, createdById: string, media?: { mediaId: string, url?: string | null, kind: Types.MediaKindEnum } | null, createdBy: { id: string, name?: string | null }, endMessageConfig?: { title: string, message?: string | null } | null, participantsConfig?: { assignToEveryone?: boolean | null, public?: boolean | null, userIds?: Array<string> | null, userGroupIds?: Array<string> | null } | null, adminConfig?: { userIds?: Array<string> | null, userGroupIds?: Array<string> | null } | null, userSurveyCommentConfig?: { allowManagerReply: boolean, viewIndirectComments: boolean } | null, dueDateConfig?: { dueDateType: Types.DueDateTypeEnum, dueDate?: string | null, value?: number | null } | null, questionConfig: { surveyQuestions: Array<{ id: string, blockType?: Types.UserSurveyQuestionBlockTypeEnum | null, order: number, questionId?: string | null, commentTitle?: string | null, conditional?: boolean | null, settings?: { isHidden?: boolean | null, isOptional: boolean, allowComments: boolean, allowAttachmentsInResponse?: boolean | null } | null, conditionConfigs?: Array<{ operator: Types.FilterOperatorEnum, actions: Array<{ actionType: Types.UserSurveyQuestionConditionActionTypeEnum, properties?: Array<{ type: Types.FilterPropertyTypeEnum, values?: Array<string> | null }> | null }>, conditions: Array<{ operator: Types.FilterOperatorEnum, typeCast?: Types.TypeCastEnum | null, value: string, property: { type: Types.FilterPropertyTypeEnum, value: string } }> }> | null }> }, notificationConfig?: { sendEmail: boolean, subject: string, description: { text: string } } | null, automationConfig?: { isAutomated: boolean, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, value?: string | null, typeCast?: Types.TypeCastEnum | null, property?: { type: Types.FilterPropertyTypeEnum, value: string } | null, filters: Array<{ operator: Types.FilterOperatorEnum, value: string, typeCast?: Types.TypeCastEnum | null, property: { type: Types.FilterPropertyTypeEnum, value: string } }> }> } | null } | null, cadenceConfig?: { frequency: Types.CronFrequencyEnum, timezone: string, custom?: Types.CustomFrequencyEnum | null, value?: number | null, endDateConfig?: { endDate?: string | null, cycleValue?: number | null, endDateType: Types.UserSurveyEndDateTypeEnum } | null } | null };


export type UserSurveyEditorFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserSurveyConditionConfigDataFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSurveyConditionConfigData on UserSurveyConditionConfig {
  actions {
    actionType
    properties {
      type
      values
    }
  }
  operator
  conditions {
    operator
    property {
      type
      value
    }
    typeCast
    value
  }
}
    `;
export const UserSurveyQuestionsEditorFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSurveyQuestionsEditor on UserSurveyQuestionType {
  id
  blockType
  order
  questionId
  commentTitle
  settings {
    isHidden
    isOptional
    allowComments
    allowAttachmentsInResponse
  }
  conditional
  conditionConfigs {
    ...UserSurveyConditionConfigData
  }
}
    `;
export const UserSurveyEditorFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSurveyEditor on UserSurveyType {
  id
  name
  status
  type
  description
  publicId
  media {
    mediaId
    url
    kind
  }
  subWorkspaceIds
  coverOffset
  anonymityThreshold
  createdByType
  createdById
  createdBy {
    id
    name
  }
  endMessageConfig {
    title
    message
  }
  participantsConfig {
    assignToEveryone
    public
    userIds
    userGroupIds
  }
  adminConfig {
    userIds
    userGroupIds
  }
  userSurveyCommentConfig {
    allowManagerReply
    viewIndirectComments
  }
  dueDateConfig {
    dueDateType
    dueDate
    value
  }
  questionConfig {
    surveyQuestions {
      ...UserSurveyQuestionsEditor
    }
  }
  notificationConfig {
    description {
      text
    }
    sendEmail
    subject
  }
  automationConfig {
    isAutomated
    filterGroup {
      operator
      filters {
        operator
        property {
          type
          value
        }
        value
        typeCast
        filters {
          operator
          property {
            type
            value
          }
          value
          typeCast
        }
      }
    }
  }
  cadenceConfig {
    frequency
    timezone
    custom
    value
    endDateConfig {
      endDate
      cycleValue
      endDateType
    }
  }
}
    `;